import { defineMessages } from 'react-intl';

export const donorInfo = defineMessages({
	title: {
		id: 'NewCcf_DonorInfoHelpTitle',
		defaultMessage: 'Donor Information'
	},
	firstName: {
		id: 'NewCcf_DonorFirstName',
		defaultMessage: 'First Name:'
	},
	middleName: {
		id: 'NewCcf_DonorMiddleName',
		defaultMessage: 'Middle Name:'
	},
	lastName: {
		id: 'NewCcf_DonorLastName',
		defaultMessage: 'Last Name:'
	},
	fullName: {
		id: 'CcfPwa_FullName',
		defaultMessage: 'Full Name:'
	},
	donorId: {
		id: 'CcfPwa_DonorIdLabel',
		defaultMessage: 'Donor ID Number:'
	},
	donorIdType: {
		id: 'NewCcf_DonorIdType',
		defaultMessage: 'Donor ID Type'
	},
	collectionNotes: {
		id: 'NewCcf_Comments',
		defaultMessage: 'Collection Notes:'
	},
	dateOfBirth: {
		id: 'NewCcf_DonorDob',
		defaultMessage: 'Date of Birth'
	},
	donorEmail: {
		id: 'NewCcf_DonorEmail',
		defaultMessage: 'Email Address:'
	},
	donorSex: {
		id: 'NewCcf_DonorSex',
		defaultMessage: 'Gender:'
	},
	additionalQuestions: {
		id: 'NewCcf_AdditionalQuestions',
		defaultMessage: 'Additional Questions'
	},
	laboratoryQuestions: {
		id: 'NewCcf_LaboratoryQuestions_Title',
		defaultMessage: 'Laboratory Questions'
	},
	donorSex34: {
		id: 'Shared_DonorSex_34',
		defaultMessage: 'Male'
	},
	donorSex35: {
		id: 'Shared_DonorSex_35',
		defaultMessage: 'Female'
	},
	donorSex40: {
		id: 'Shared_DonorSex_40',
		defaultMessage: 'Prefer not to declare'
	},
	mroTitle: {
		id: 'NewCcf_MroInformationHeader',
		defaultMessage: 'Medical Information'
	},
	declarationQuestion: {
		id: 'NewCcf_MedicationDeclarationQuestion',
		defaultMessage: 'Are you taking any medication?'
	},
	declarationOption1: {
		id: 'NewCcf_MedicationDeclaration_1',
		defaultMessage: 'I am taking medication.'
	},
	declarationOption2: {
		id: 'NewCcf_MedicationDeclaration_2',
		defaultMessage: 'I am not and have not taken medication in the last 14 days.'
	},
	declarationOption3: {
		id: 'NewCcf_MedicationDeclaration_3',
		defaultMessage: 'I am taking medication, but do not wish to declare it.'
	},
	declarationOption4: {
		id: 'NewCcf_MedicationDeclaration_4',
		defaultMessage: 'Prefer not to answer.'
	},
	prescriptions: {
		id: 'NewCcf_DonorPrescriptions',
		defaultMessage: 'Prescriptions:'
	},
	phoneNumber: {
		id: 'NewCcf_DonorPhone',
		defaultMessage: 'Daytime Phone:'
	},
	eveningPhoneNumber: {
		id: 'NewCcf_DonorEveningPhone',
		defaultMessage: 'Evening Phone:'
	},
	donorFieldsLocked: {
		id: 'NewCcf_DonorFieldsLocked',
		defaultMessage: 'These fields cannot be updated since the donor signature has been collected.'
	}
});

export const donorSignature = defineMessages({
	title: {
		id: 'NewCcf_HeaderDonorSignature',
		defaultMessage: 'Donor Signature'
	},
	donorName: {
		id: 'NewCcf_SignatureDonorName',
		defaultMessage: 'Donor name'
	},
	dateOfBirth: {
		id: 'NewCcf_DonorDob',
		defaultMessage: 'Date of Birth'
	},
	collectionDate: {
		id: 'NewCcf_CollectionDateTime',
		defaultMessage: 'Collection Date and Time'
	},
	testReason: {
		id: 'NewCcf_TestReasonHelpTitle',
		defaultMessage: 'Reason for Test'
	},
	requestingAgency: {
		id: 'NewCcf_RequestingAgency',
		defaultMessage: 'Requesting Agency'
	},
	testsToPerform: {
		id: 'NewCcf_TestType',
		defaultMessage: 'Drug Tests to be Performed'
	},
	collectionSite: {
		id: 'NewCcf_CollectionSite',
		defaultMessage: 'Collection Site'
	},
	consentText: {
		id: 'NewCcf_PrintConsentFormText_002',
		defaultMessage: 'I have read or had the Donor Information Sheet read to me and I understand the reason & purpose of the test. I understand that a non-negative reaction from an onsite drug test will require laboratory confirmation analysis. I consent to proceeding with the testing process and agree to the GDPR conditions as outlined on the donor information form.'
	}
});

export const pocResults = defineMessages({
	title: {
		id: 'NewCcf_TestSubprocessTitle',
		defaultMessage: 'Test Results'
	},
	questions: {
		id: 'NewCcf_TestSubprocessPanelTitle',
		defaultMessage: 'Drug Panel Questions'
	},
	reportPanels: {
		id: 'NewCcf_TestSubprocessValidityPanelTitle',
		defaultMessage: 'Report Panels'
	},
	addAdditionalTests: {
		id: 'NewCcf_AddAdditionalPoctQuestions',
		defaultMessage: 'Add Additional Test'
	},
	imageHelp1: {
		id: 'NewCcf_Image_Help1',
		defaultMessage: 'The photo size cannot be more than 5 MB.'
	},
	imageHelp2: {
		id: 'NewCcf_Image_Help2',
		defaultMessage: 'The file types allowed are jpg and jpeg.'
	},
	imageHelp3: {
		id: 'NewCcf_Image_Help3',
		defaultMessage: 'A maximum of 4 photos are permitted.'
	},
	imageHelp4: {
		id: 'NewCcf_Image_Help4',
		defaultMessage: 'File name cannot be longer than 30 characters.'
	},
	negativeNotes: {
		id: 'NewCcf_WasSpecimenResultNegativeNotes',
		defaultMessage: 'Report Notes (These comments will only appear on POCT report):'
	},
	positiveCheckFailed: {
		id: 'NewCcf_OverallResultPositiveHasDrugMarkedPositiveCheckFailed',
		defaultMessage: 'Overall result of "Non-Negative" requires at least a substance which tested with result "Non-Negative".'
	},
	mustBePositive: {
		id: 'NewCcf_OverallResultMustBePositiveCheckFailed',
		defaultMessage: 'Overall result must be "Non-Negative" if there are any substances that tested positive.'
	},
	overallResult: {
		id: 'NewCcf_TestSubprocessOverallResultQuestion',
		defaultMessage: 'What is the overall result?'
	}
});

export const printSummary = defineMessages({
	title: {
		id: 'NewCcf_PrintOptions',
		defaultMessage: 'Select Forms to Print in Summary'
	},
	printLabForms: {
		id: 'NewCcf_PrintCcfLaboratoryFormHeaderText',
		defaultMessage: 'Print Laboratory Forms'
	},
	selectAll: {
		id: 'NewCcf_PrintOption_All',
		defaultMessage: 'Select All'
	},
	custodyForm: {
		id: 'NewCcf_PrintOption_Ccf',
		defaultMessage: 'Chain of Custody Form'
	},
	releaseForm: {
		id: 'NewCcf_PrintOption_ReleaseForm',
		defaultMessage: 'Release Form'
	},
	printSelected: {
		id: 'NewCcf_PrintSelectedForms',
		defaultMessage: 'Print Selected Forms'
	},
	additionalForms: {
		id: 'NewCcf_AddlFormsLabel',
		defaultMessage: 'Additional Forms and Statements'
	},
	privacyPolicy: {
		id: 'CcfPwa_PrivacyPolicy',
		defaultMessage: 'Privacy Policy'
	},
	donorInfoSheet: {
		id: 'CcfPwa_DonorInformationSheet',
		defaultMessage: 'Donor Information Sheet'
	},
	failureToConsent: {
		id: 'CcfPwa_FailureToConsent',
		defaultMessage: 'Failure to Consent'
	},
	printDonorForms: {
		id: 'NewCcf_PrintCcfDonorFormHeaderText',
		defaultMessage: 'Print Donor Forms'
	},
	printDonorCopy: {
		id: 'NewCcf_PrintCcfDonorFormButtonText',
		defaultMessage: 'Print Donor Copy'
	},
	completedForm: {
		id: 'NewCcf_CompletedCcf',
		defaultMessage: `<p>You've successfully completed your Chain of Custody Form (CCF). You can print the CCF at this time from the popup window, or select the Print Chain of Custody button above to print the form.</p><p>Please package and forward the sample, with the completed chain of custody document, to the testing laboratory, following the testing laboratory's standard procedures.</p>`
	},
	forQuestions: {
		id: 'CcfPwa_ContactClientServices',
		defaultMessage: `<p>If you have any questions, please contact Client Services at +1.330.628.5748</p>`
	},
	testResults: {
		id: 'NewCcf_PrintOption_TestResults',
		defaultMessage: 'Test Results'
	},
	includeCopyOne: {
		id: 'CcfPwa_MustIncludeCopyOne',
		defaultMessage: 'You must include Copy 1 of the document when sending this sample to the lab.'
	},
	printForms: {
		id: 'CcfPwa_PrintForms',
		defaultMessage: 'Print Forms'
	},
	printLabCopy: {
		id: 'CcfPwa_PrintLabCopy',
		defaultMessage: 'Print Lab Copy'
	},
	printCollectorCopy: {
		id: 'CcfPwa_PrintCollectorCopy',
		defaultMessage: 'Print Collector Copy'
	},
	printEmployerCopy: {
		id: 'CcfPwa_PrintEmployerCopy',
		defaultMessage: 'Print Employer Copy'
	},
	printMroCopy: {
		id: 'CcfPwa_PrintEmployerCopy',
		defaultMessage: 'Print MRO Copy'
	},
	confirmReprint: {
		id: 'CcfPwa_ConfirmReprint',
		defaultMessage: 'Confirm Reprint'
	},
	pleasePrintAndSign: {
		id: 'CcfPwa_PrintAndSign',
		defaultMessage: 'Please print and a <b>WET SIGNATURE IS REQUIRED</b> next to the current electronic signature on Copy 1 of the CCF.'
	}
});

export const requestingAgency = defineMessages({
	title: {
		id: 'NewCcf_PageTitle',
		defaultMessage: 'Select a Client/Requesting Agency'
	},
	agencyLabel: {
		id: 'NewCcf_RequestingAgency',
		defaultMessage: 'Requesting Agency'
	},
	selectAgencyLabel: {
		id: 'CcfPwa_SelectClientAgency',
		defaultMessage: 'Select Client/Requesting Agency for Test to be Performed'
	},
	subaccountName: {
		id: 'CcfPwa_SubAccountName',
		defaultMessage: 'If Client/Requesting Agency not found in drop down, select the "Generic Account" for the Client/Requesting Agency and type in Name of the sub-account sample is being collected for in the field below'
	},
	customAddress: {
		id: 'NewCcf_CollectionSiteOverideNameQuestion',
		defaultMessage: 'I want to specify a different collection site address'
	},
	customName: {
		id: 'NewCcf_CollectionSiteOverideName',
		defaultMessage: `Donor's Organisation:`
	},
	customAddress1: {
		id: 'NewCcf_CollectionSiteOverideAddress1',
		defaultMessage: 'Address Line 1:'
	},
	customAddress2: {
		id: 'NewCcf_CollectionSiteOverideAddress2',
		defaultMessage: 'Address Line 2:'
	},
	customCity: {
		id: 'NewCcf_CollectionSiteOverideCity',
		defaultMessage: 'City:'
	},
	customState: {
		id: 'NewCcf_CollectionSiteOverideStateRegion',
		defaultMessage: 'Location/BU'
	},
	customZip: {
		id: 'NewCcf_DonorPostalCode',
		defaultMessage: 'Postal Code:'
	},
	customPhone: {
		id: 'NewCcf_CollectionSiteOveridePhone',
		defaultMessage: 'Phone:'
	},
	customNamePlaceholder: {
		id: 'NewCcf_CollectionSiteOverideNamePlaceHolder',
		defaultMessage: 'Enter Donors Organisation'
	},
	customAddress1Placeholder: {
		id: 'NewCcf_CollectionSiteOverideAddress1PlaceHolder',
		defaultMessage: 'Enter Address Line 1'
	},
	customAddress2Placeholder: {
		id: 'NewCcf_CollectionSiteOverideAddress2PlaceHolder',
		defaultMessage: 'Enter Address Line 2'
	},
	customCityPlaceholder: {
		id: 'NewCcf_CollectionSiteOverideCityPlaceHolder',
		defaultMessage: 'Enter City'
	},
	customStatePlaceholder: {
		id: 'NewCcf_CollectionSiteOverideStateRegionPlaceHolder',
		defaultMessage: 'Enter Location/BU'
	},
	customZipPlaceholder: {
		id: 'NewCcf_CollectionSiteOveridePostalCodePlaceHolder',
		defaultMessage: 'Enter Postal Code'
	},
	customPhonePlaceholder: {
		id: 'NewCcf_CollectionSiteOveridePhonePlaceHolder',
		defaultMessage: 'Enter Phone'
	},
	derName: {
		id: 'CcfPwa_DERName',
		defaultMessage: 'DER Name'
	},
	derPhone: {
		id: 'CcfPWa_DERPhone',
		defaultMessage: 'DER Phone'
	}
});

export const sampleTypes = defineMessages({
	title: {
		id: 'NewCcf_AdditionalInfoHelpTitle',
		defaultMessage: 'Specimen Type and Additional Information'
	},
	specimenType: {
		id: 'TestRequestForm_SpecimenType',
		defaultMessage: 'Specimen Type:'
	},
	testsToPerform: {
		id: 'TestRequestForm_TestToPerform',
		defaultMessage: 'Drug Tests to be Performed:'
	},
	laboratory: {
		id: 'NewCcf_Laboratory',
		defaultMessage: 'Laboratory:'
	},
	testReason: {
		id: 'NewCcf_TestReason',
		defaultMessage: 'Reason for Test:'
	},
	noTests: {
		id: 'CcfPwa_NoTestsAvailable',
		defaultMessage: 'No tests available. Please select a different Specimen Type.'
	},
	noLabs: {
		id: 'CcfPwa_NoLaboratoriesAvailable',
		defaultMessage: 'No laboratories available. Please select a different Specimen Type.'
	},
	numberOfSamples: {
		id: 'NewCcf_NumberOfSamples',
		defaultMessage: 'How many samples are being collected?'
	},
	numberOfSamples1: {
		id: 'NewCcf_NumberOfSamplesOption1',
		defaultMessage: '"A" Sample (single sample)'
	},
	numberOfSamples2: {
		id: 'NewCcf_NumberOfSamplesOption2',
		defaultMessage: '"A" and "B" Sample (split sample)'
	},
	numberOfSamples3: {
		id: 'NewCcf_NumberOfSamplesOption3',
		defaultMessage: '"A", "B" and "C" Sample (split sample)'
	},
	additionalTests: {
		id: 'CcfPwa_AdditionalTests',
		defaultMessage: 'Additional Tests to be Performed'
	},
	specifyTestReason: {
		id: 'CcfPwa_PleaseSpecify',
		defaultMessage: 'Please specify:'
	},
	splitType: {
		id: 'CcfPwa_SplitType',
		defaultMessage: 'Split Type:'
	}
});

export const specimenDetails = defineMessages({
	title: {
		id: 'CcfPwa_SpecimenDetailsTitle',
		defaultMessage: 'Confirm Sample Details'
	},
	hairLocation: {
		id: 'NewCcf_HairLocation',
		defaultMessage: 'Hair Location'
	},
	hairLocationDetail: {
		id: 'NewCcf_HairLocationDetail',
		defaultMessage: 'Please specify body location (optional):'
	},
	comments: {
		id: 'NewCcf_Comments',
		defaultMessage: 'Collection Notes:'
	},
	collectionDate: {
		id: 'NewCcf_CollectionDateTime',
		defaultMessage: 'Collection Date and Time:'
	},
	deliveryService: {
		id: 'NewCcf_DeliveryService',
		defaultMessage: 'Delivery Service'
	},
	deliveryServiceDefault: {
		id: 'CcfPwa_DeliveryServiceDefault',
		defaultMessage: 'Courier'
	},
	urineTemperature: {
		id: 'NewCcf_UrineTemperatureC',
		defaultMessage: 'Is temperature between 33° and 37°C (Inclusive)?'
	},
	specimenYes: {
		id: 'CocReportForm_SpecimenYes_Label',
		defaultMessage: 'Yes'
	},
	specimenNo: {
		id: 'CocReportForm_SpecimenNo_Label',
		defaultMessage: 'No. Enter Remark Below'
	},
	specimenObserved: {
		id: 'CcfPwa_ObservedEnterRemarkBelow',
		defaultMessage: 'Observed. Enter Remark Below'
	},
	specimenRemarks: {
		id: 'CocReportForm_Step2Comments_2',
		defaultMessage: 'Remarks:'
	},
	volumeIndicatorObserved: {
		id: 'CcfPwa_VolumeIndicatorObserved',
		defaultMessage: 'Volume Indicator Observed'
	},
	enterSpecimenId: {
		id: 'CocReportForm_TestResults_Specimen',
		defaultMessage: 'Specimen ID:'
	},
	scanSpecimenId: {
		id: 'NewCcf_ScanSpecimenId',
		defaultMessage: 'Enter/Scan Specimen ID'
	},
	confirmSpecimenId: {
		id: 'NewCccf_ConfirmSpecimenId',
		defaultMessage: 'Confirm Specimen ID'
	},
	remarks: {
		id: 'CcfPwa_RemarksLabel',
		defaultMessage: 'Remarks'
	},
	specimenIdsMustMatch: {
		id: 'NewCcf_SpecimenIdsMustMatch',
		defaultMessage: 'Specimen IDs Must Match'
	}
});

export const withdrawalComplete = defineMessages({
	title: {
		id: 'NewCcf_DonorWithdrawalCompletionTitle',
		defaultMessage: 'Donor Withdrawal Complete'
	},
	withdrawalComplete: {
		id: 'NewCcf_DonorWithdrawalCompletionText',
		defaultMessage: 'This collection has been marked in the system as a donor withdrawal. This completes this collection and no further processing is needed at this time.'
	}
});

export const ccfSummary = defineMessages({
	title: {
		id: 'NewCcf_CcfSummary',
		defaultMessage: 'Chain of Custody Summary'
	},
	questions: {
		id: 'NewCcf_TestSubprocessPanelTitle',
		defaultMessage: 'Drug Panel Questions'
	},
	reportPanels: {
		id: 'NewCcf_TestSubprocessValidityPanelTitle',
		defaultMessage: 'Report Panels'
	},
	printCcf: {
		id: 'NewCcf_PrintCcfFormButtonText',
		defaultMessage: 'Print Chain of Custody'
	},
	printDonorCopy: {
		id: 'NewCcf_PrintCcfDonorFormButtonText',
		defaultMessage: 'Print Donor Copy'
	},
	showTestResult: {
		id: 'NewCcf_ShowPocDrugPanelResultsLink',
		defaultMessage: 'Show Test Result'
	},
	hideTestResult: {
		id: 'CcfPwa_HideTestResult',
		defaultMessage: 'Hide Test Result'
	}
});

export const lotDetails = defineMessages({
	title: {
		id: 'CcfPwa_CollectionDeviceDetails',
		defaultMessage: 'Collection Device Details'
	},
	breathTitle: {
		id: 'CcfPwa_BreathCollectionDetails',
		defaultMessage: 'Breath Cartridge'
	},
	lotNumber: {
		id: 'NewCcf_LabLotNumber',
		defaultMessage: 'Lot Number:'
	},
	deviceExpiration: {
		id: 'CcfPwa_CollectionDeviceExpirationDate',
		defaultMessage: 'Expiration Date'
	},
	breathSerialNumber: {
		id: 'CcfPwa_BreathDeviceSerialNumber',
		defaultMessage: 'Breath Collection Unit Serial Number'
	},
	breathTestCalibrationDueDate: {
		id: 'NewCcf_CalibrationDueDate',
		defaultMessage: 'Calibration Due Date'
	},
	breathTestLastCalibrationDate: {
		id: 'CcfPwa_LastCalibrationDate',
		defaultMessage: 'Last Calibration Date'
	},
	breathDevicePassedSelfTest: {
		id: 'CcfPwa_DevicePassedSelfTest',
		defaultMessage: 'System Selftest Passed'
	},
	ambientAirProvided: {
		id: 'CcfPwa_AmbientAirTestProvided',
		defaultMessage: 'Ambient Air Being Collected'
	},
	ambientAirYes: {
		id: 'CcfPwa_AmbientAirYes',
		defaultMessage: 'Yes'
	},
	ambientAirNo: {
		id: 'CcfPwa_AmbientAirNo',
		defaultMessage: 'No'
	}
});

export const sendToLaboratory = defineMessages({
	title: {
		id: 'CcfPwa_FinalizeCollection',
		defaultMessage: 'Finalize Collection'
	},
	sendToLab: {
		id: 'NewCcf_SendToLaboratory',
		defaultMessage: 'Is the sample being sent to a laboratory?'
	},
	sendYes: {
		id: 'ConsentForm_Yes',
		defaultMessage: 'Yes'
	},
	sendNo: {
		id: 'ConsentForm_No',
		defaultMessage: 'No'
	},
	randomVerification: {
		id: 'NewCcf_Require_Verification_Text',
		defaultMessage: 'This sample has been selected for random QA check. It is important that you send this sample to the laboratory for verification.'
	}
});
